import * as stylex from "@stylexjs/stylex";
import { size } from "./tokens.stylex";

export const switchConfig = stylex.defineVars({
	width: size.px10,
	height: size.px5,
	labelGap: size.px2,
});

export const sliderConfig = stylex.defineVars({
	size: `calc(${switchConfig.height} - 2px)`,
	offset: "1px",
	translationOffset: size.px5,
});
